//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faBorderCenterH,
  faCode,
} from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'LottieBenefits',
  data() {
    return {
      faBorderCenterH,
      faCode,
    };
  },
};
